import React, { useEffect } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { useDataService } from '../hooks/useDataService';
import Footer from './Footer';
import { ContactSection } from './features/ContactSection';
import { motion } from "motion/react";



const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const TopPageContainer = styled.div.attrs({className: 'page-container'})`

 .contact-section {
  @media (max-width: 768px) {
    margin-right:20px;
    margin-left:20px;
  }
 }
`;

const TopBannerImage = styled.div.attrs({className: 'top-banner'})<{ $imageSrc: string }>`
  width: 100%;
  background-color: #0F3F8E;
  background-size: cover;
  background-position: bottom;
  margin-bottom: 0;
  position: relative;
  scroll-snap-align: start;

  @media (min-width: 769px) {
    height: calc(100vh - 80px);
    background-position: center;
  }
`;


const TopText = styled.div.attrs({className: 'top-text'})`
  position: absolute;
  top:10%;
  left:8%;
  max-width: var(--contents-maxwidth-pc);
  
  
  height: auto; /* pタグの高さを画像に合わせる */
  z-index: 10;

  @media (min-width: 769px) {
    
    left: 50%;
    width: 95%;
    transform: translateX(-50%);
  }
`;

const TopTextInner = styled.div.attrs({className: 'top-text-inner'})`
  width:fit-content;
`;

const MotionTopTextInner = motion(TopTextInner);

const TopTextVector1 = styled.picture`
  display: block;
  margin-bottom: 7.4%;
  @media (min-width: 769px) {
    margin-bottom: 45px;
  }
    img {
      display: block; /* 下の隙間を消す */
      width: 68vw;
      height: 100%;
      object-fit: contain;
    }
    @media (min-width: 769px) {
      img {
        width: auto;
        height: 47px;
        object-fit: contain;
      }
    }
`;

const TopTextVector2 = styled.img`
  width: 60.5vw;
  height: auto;
  display: block; /* 下の隙間を消す */
  @media (min-width: 769px) {
    width: auto;
    height: 60px;
    object-fit: contain;
  }
`;

const TopTextLiner = styled.div.attrs({className: 'top-text-liner'})`
  position: relative;
  .top-text-vector-2-2 {
    position: absolute;
    top: 50%;
    left: 3%;
    transform: translateY(-50%);
    width: 40vw;
    height: auto;
  }
  @media (min-width: 769px) {
    .top-text-vector-2-2 {
      width: auto;
      height: 96.4px;
      left: 14px;
    }
  }
`;

const HeroSection = styled.section.attrs({className: 'hero-section'})`
  //margin: 0 auto;
  background: #0F3F8E;
  color: #FFFFFF;
  height: 850px;
  padding: 130px 0 142px;
  position: relative;
  overflow: hidden;
  scroll-snap-align: start;

  @media (max-width: 768px) {
    padding: 60px 20px;
    
    /* Mobile-specific spacing */
    & > * + * {
      margin-top: 30px;
    }
  }
`;

const HeroContent = styled.div.attrs({className: 'hero-content'})`
  max-width: var(--contents-maxwidth-pc);
  margin-right: auto;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
  align-items: flex-start;

  @media (min-width: 769px) {
    flex-direction: row;
    gap: 211px;
    width: 95%;
  }
`;

const HeroText = styled.div.attrs({className: 'hero-text'})`
  //flex: 1.5;
  width: 835px;
  //max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  @media (max-width: 768px) {
    max-width: 100%;
    order: 2;
  }
`;

const HeroTitle = styled.h1.attrs({className: 'hero-title'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 36px;
  line-height: 1.5;
  letter-spacing: 0.05em;
  margin: 0 0 30px 0;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 1.4;
    margin: 0 0 20px 0;
  }
`;

const HeroDescription = styled.p.attrs({className: 'hero-description'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.75;
  margin: 0 0 40px 0;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.6;
    margin: 0 0 30px 0;
  }
`;

const HeroButton = styled(Link).attrs({className: 'hero-button'})`
  display: flex;
  align-items: center;
  gap: 20px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  padding: 0;
  transition: color 0.3s ease;
  align-self: flex-end;
  text-decoration: none;

  // &:hover {
  //   color: #0F3F8E;
  // }

  @media (max-width: 768px) {
    display: none;
  }
`;

const HeroButtonArrow = styled.img.attrs({className: 'hero-arrow'})`
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
`;


const LinkRightIcon = styled.img.attrs({className: 'right-icon'})`
  width: 16px;
  height: 16px;
`;

const HeroLeftSide = styled.div.attrs({className: 'hero-left'})`
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  @media (max-width: 768px) {
    order: 1;
    width: 100%;
  }
`;


const PhilosophyTitle = styled.div.attrs({className: 'philosophy-title'})`
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: 768px) {
    width: 100%;
  }
`;



const HeroImageList = styled.div.attrs({className: 'hero-image-list'})`
  animation: ${scroll} 40s linear infinite;
  display: inline-flex;
  justify-content: center;
  height: 300px;
  margin-top: 40px;

  @media (max-width: 768px) {
    height: unset;
    margin-top: 30px;
    padding: 0;
    /* Mobile-specific improvements */
    & > * {
      margin-bottom: 0;
    }
    & > *:last-child {
      margin-bottom: 0;
    }
  }
`;

const HeroImageItem = styled.picture.attrs({className: 'hero-image-item'})`
  img {
    display: block;
    width: 518.76px;
    height: 300px;
    border-radius: 20px;

    @media (max-width: 768px) {
    width:auto;
      height: 200px;
      border-radius: 25px;
    }
  }
`;

const HeroImangeWrapper = styled.div`padding-right:20px; @media (max-width: 768px) {padding-right: 15px;}`;

const MobileHeroButton = styled(HeroButton).attrs({className: 'mobile-hero-button'})`
  display: none; /* Hide by default */
  @media (max-width: 768px) {
    display: flex;
    justify-content: flex-end;
    min-height: 44px; /* Touch-friendly button size */
  }
`;





const SectionTitle = styled.div.attrs({className: 'section-title'})`
  text-align: left;
  margin-bottom: 60px;
  flex: 1;

  @media (max-width: 768px) {
    margin-bottom: 40px;
  }
`;

const MainTitle = styled.h2.attrs({className: 'main-title'})`
  font-family: 'A P-OTF Aoto Gothic StdN', 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 11.73vw;
  line-height: 1.5;
  letter-spacing: 0.05em;
  color: #333333;
  margin: 0 0 10px 0;

  @media (min-width: 769px) {
    font-size: 56px;
  }
`;

const MainTitleWhite = styled.h2.attrs({className: 'main-title-white'})`
  font-family: 'A P-OTF Aoto Gothic StdN', 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 11.73vw;
  line-height: 2em;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  margin: 0;

  @media (min-width: 769px) {
    font-size: 56px;
    line-height: 2;
  }
`;

const SubTitle = styled.h3.attrs({className: 'sub-title'})`
  font-family: 'ITC Avant Garde Gothic Pro', 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 4.8vw;
  line-height: normal;
  letter-spacing: 0.9px;
  color: #9B9B9B;
  margin: 0;
  font-style: italic;
  @media (min-width: 769px) {
    font-size: 18px;
  }
`;

const ServicePreviewSection = styled.section.attrs({className: 'service-preview-section'})`
  max-width: var(--contents-maxwidth-pc);
  margin: 0 auto;
  scroll-snap-align: start;
  padding: 60px 20px;
  @media (min-width: 769px) {
    padding: 120px 0 0;
    width: 95%;
  }
`;

const ServiceDescription = styled.div.attrs({className: 'service-descrption'})`
  text-align: left;

  @media (min-width: 769px) {
    flex: 2;
  }
`;

const ServiceDescriptionTitle = styled.h2`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 36px;
  line-height: 1.5;
  letter-spacing: 0.05em;
  color: #333333;
  margin: 0 0 30px 0;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 1.4;
    margin: 0 0 20px 0;
  }
`;

const ServiceDescriptionText = styled.p.attrs({className: 'service-description-text'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.75;
  color: #333333;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.6;
  }
`;

const ServicePreviewContainer = styled.div.attrs({className: 'coservice-preview-container'})`
  display: flex;
  align-items: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
  }
`;


const ServiceSectionTitle = styled(SectionTitle).attrs({className: 'service-section-title'})`
    margin-bottom: 0;
    flex: 1;
  }
`;

const ServicePreviewGrid = styled.div.attrs({className: 'service-preview-grid'})`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  margin-top: 17%;

  @media (min-width: 769px) {
    flex-wrap: nowrap;
    flex-direction: row;
    margin-top: 30px;
    padding: 0;
    

  }
`;

const ServicePreviewCard = styled(Link).attrs({className: 'service-preview-card'})`
  position: relative;
  width: 100%;
  text-decoration: none;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 10% 6.7%;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:not(:last-child) {
    margin-bottom: 6%;
  }

  @media (min-width: 769px) {
    width: 31.25%;
    padding: 50px;
    gap: 20px;
    text-align: left;
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;



const ServicePreviewImage = styled.picture.attrs({className: 'service-preview-image'})`
  width: 100%;
  img {width: 100%;vertical-align:bottom;}
`;

const ServicePreviewContent = styled.div.attrs({className: 'service-preview-content'})`
  flex: 1;
  width: 100%;
`;

const ServicePreviewTitle = styled.h3.attrs({className: 'service-preview-title'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.75;
  letter-spacing: 0.05em;
  color: #333333;
  margin: 25px 0 20px 0;

  @media (min-width: 769px) {
    font-size: 24px;
    margin-top:0;
    margin-bottom: 8px;
  }
`;

const ServicePreviewDescription = styled.p.attrs({className: 'service-preview-description'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.75;
  color: #333333;
  margin: 0 0 40px 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.6;
    margin: 0 0 20px 0;
  }
`;

const ServicePreviewButton = styled.div.attrs({className: 'service-preview-button'})`
  position: absolute;
  right: 10%;
  bottom: 6.7%;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 15px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: 0.05em;
  color: #333333;
  padding: 0;
  transition: color 0.3s ease;
  

  @media (min-width: 769px) {
    justify-content: end;
    gap: 20px;
    right: 50px;
    bottom: 50px;
    &:hover {
      color: #0F3F8E;
    }
  }
`;

const ServicePreviewButtonArrow = styled.img.attrs({className: 'service-preview-button-arrow'})`
  width: 16px;
  height: 16px;
`;

const ClientSection = styled.section.attrs({className: 'client-section'})`
  padding: 140px 0;
  scroll-snap-align: start;

  @media (max-width: 768px) {
    padding: 60px 0;
    
    /* Mobile-specific spacing */
    & > * + * {
      margin-top: 30px;
    }
  }
`;

const ClientContainer = styled.div.attrs({className: 'client-container'})`
  // max-width: var(--contents-maxwidth-pc);
  // margin: 0 auto;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`;

const ClientSectionTitle = styled(SectionTitle).attrs({className: 'clent-section-title'})`
  max-width: var(--contents-maxwidth-pc);
  margin: 0;
  padding: 0 20px;
  margin-bottom: 70px;
  @media (min-width: 769px) {
    padding: 0;
    margin: 0 auto 76px;
    width: 95%;
  }

`;

// ロゴのベース配列
const BASE_LOGOS = [
  '/assets/images/top/client-logo-sb.svg',
  '/assets/images/top/client-logo-ctc.svg',
  '/assets/images/top/client-logo-dd.svg',
  '/assets/images/top/client-logo-bn.png',
  '/assets/images/top/client-logo-sch.svg',
  '/assets/images/top/client-logo-dnp.png',
];
// 無限ループのために配列を2倍（[a,b,c, a,b,c]）にする
const INFINITE_LOGOS = [...BASE_LOGOS, ...BASE_LOGOS, ...BASE_LOGOS];

const ClientLogos = styled.div.attrs({className: 'client-logos'})`
  display:  flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow: hidden;
  @media (max-width: 768px) {
    
    /* Mobile-specific logo layout */
    justify-content: space-around;
    
    & > * {
      flex: 0 0 auto;
      margin-bottom: 20px;
    }
  }
`;

const ClientLogo = styled.img.attrs({className: 'client-logo'})`
  height: 30px;
  object-fit: contain;
  padding-right: 60px;
  object-fit: contain;

  @media (max-width: 768px) {
    height: 5.33vw;
    padding-right: 30px;
  }
`;

const RecruitmentSection = styled.section.attrs({className: 'recruitment-section'})`
  padding: 0;
  background: #0F3F8E;
  color: #FFFFFF;
  position: relative;
  // overflow: hidden;
  scroll-snap-align: start;
  @media (max-width: 768px) {
    margin-bottom: 80px;
  }

`;

const RecruitmentContainer = styled.div.attrs({className: 'recruitment-container'})`
  flex: 0 0 auto;
  max-width: var(--contents-maxwidth-pc);
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 90px;
  padding: 116px 0;
  position: relative;
  scroll-snap-align: start;

  @media (max-width: 768px) {
    flex-direction: column;
    flex-direction: column-reverse;
    gap: 40px;
    padding: 60px 20px;
    height: unset;
  }
  @media (min-width: 769px) {
    width: 95%;
    height: 530px;
    box-sizing: content-box;
  }
`;

const RecruitmentLeftSide = styled.div.attrs({className: 'recruitment-slide'})`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media (max-width: 768px) {
    order: 2;
  }
`;

const RecruitmentSubsectionTitle = styled.div.attrs({className: 'recruitment-subsection-title'})`
  text-align: left;
  margin-bottom: 0;

  @media (max-width: 768px) {
    padding: 0;
  }
`;

const RecruitmentText = styled.div.attrs({className: 'recruitment-text'})`
  flex: 1;
  max-width: 600px;
`;

const RecruitmentTitle = styled.h2.attrs({className: 'recruitment-title'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 36px;
  line-height: 1.5;
  letter-spacing: 0.05em;
  margin: 0 0 30px 0;

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 1.4;
    margin: 0 0 20px 0;
  }
`;

const RecruitmentDescription = styled.p.attrs({className: 'recruitment-description'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.75;
  margin: 0 0 40px 0;

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 1.6;
    margin: 0 0 30px 0;
  }
`;

const RecruitmentButtons = styled.div.attrs({className: 'recruitment-buttons'})`
  display: flex;
  gap: 15px;

  @media (min-width: 769px) {
    gap: 20px;
  }
`;

const RecruitmentButton = styled(Link).attrs({className: 'recruitment-button'})`
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 20px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: 0.05em;
  color: #FFFFFF;

  @media (max-width: 768px) {
    gap: 15px;
    padding: 10px 0;
    min-height: 44px; /* Touch-friendly button size */
  }
`;

const RecruitmentImageWrapper = styled.div.attrs({className: 'recruitment-image-wrapper'})`
  @media (min-width: 769px) {
    flex: 1;
    height: 100%;
    overflow: hidden;
  }
`;

const RecruitmentImage = styled.picture.attrs({className: 'recruitment-image'})`
  position: relative;
  width: 100%;
  height: auto;
  display: block;
    @media (min-width: 769px) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
      img {width: 100%;}
`;

const NewsSection = styled.section.attrs({className: 'news-section'})`
  max-width: var(--contents-maxwidth-pc);
  //margin: 0 auto;
  padding: 60px 20px;
  
  margin-right: auto;
  margin-left: auto;
  scroll-snap-align: start;

  @media (min-width: 769px) {
    padding: 120px 0 95px;
    width: 95%;
  }
`;

const NewsContainer = styled.div.attrs({className: 'news-container'})`
  // max-width: 1280px;
  // margin: 0 auto;
`;

const NewsHeader = styled.div.attrs({className: 'news-header'})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
    margin-bottom: 40px;
    align-items: flex-start;
  }
`;

const NewsSectionTitle = styled(SectionTitle).attrs({className: 'news-section-title'})`
  margin-bottom: 0;
`;


const NewsButton = styled(Link).attrs({className: 'news-button'})`
  text-decoration: none;
  padding-top: 39px;
  display: flex;
  align-self: flex-end;
  align-items: center;
  gap: 20px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: 0.05em;
  color: #333333;
  //padding: 0;
  transition: color 0.3s ease;

  &:hover {
    color: #0F3F8E;
  }

  @media (max-width: 768px) {
    gap: 15px;
    padding: 10px 0;
    min-height: 44px; /* Touch-friendly button size */
    display: none;
  }
`;

const NewsButtonMobile = styled(NewsButton).attrs({className: 'news-butto-mobile'})`
  display: none;
  @media (max-width: 768px) {
    display: flex;
  }

`;

const NewsButtonArrow = styled.img.attrs({className: 'news-button-arrow'})`
  width: 16px;
  height: 16px;
`;

const NewsContent = styled.div.attrs({className: 'news-content'})`
  display: flex;
  gap: 155px;
  align-items: flex-start;
  height: 406px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 40px;
    height: unset;
  }
`;

const NewsLeftSide = styled.div.attrs({className: 'news-left-side'})`
  display: flex;
  flex-direction: column;
  //gap: 20px;
  text-wrap: nowrap;
  width: 200px;
  height: 309px;

  @media (max-width: 768px) {
    width: 100%;
    height: unset;
    text-wrap: wrap;
  }
`;

const FilterContainer = styled.div.attrs({className: 'filter-container'})`
  }
`;

const NewsCategories = styled.div.attrs({className: 'news-categories'})`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    
    /* Mobile-specific category layout */
    & > * {
      flex: 0 0 auto;
      white-space: nowrap;
    }
  }
    @media (min-width: 769px) {
    padding: 46px 0;
    }
`;

const CategoryFilterDivider = styled.div.attrs({className: 'category-filter-divider'})`
  height: 1px;
  background: #E5E5E5;
  //margin: 0 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NewsRightSide = styled.div.attrs({className: 'news-right-side'})`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const NewsItem = styled(Link).attrs({className: 'news-item'})`
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px 0;
  border-bottom: 1px solid #E5E5E5;
  
  &:first-child {
    border-top: 1px solid #E5E5E5;
  }

  @media (max-width: 768px) {
    padding: 15px 0;
  }
  @media (min-width: 769px) {
    transition: opacity 0.3s ease;
    &:hover {
      opacity: 0.7;
      .news-item-arrow{
        transform: translateX(5px);
      }
    }
  }
`;

const NewsItemContent = styled.div.attrs({className: 'news-item-content'})`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

const NewsItemTitle = styled.h3.attrs({className: 'news-item-title'})`
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.75;
  letter-spacing: 0.05em;
  color: #333333;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 1.5;
  }
`;

const NewsItemMeta = styled.div.attrs({className: 'news-item-meta'})`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  align-items: center;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #9B9B9B;

  @media (max-width: 768px) {
    font-size: 14px;
    gap: 15px;
  }
`;

const CategoryTag = styled.span.attrs({className: 'category-tag'})<{ $color: string }>`
  background: ${props => props.$color};
  color: #FFFFFF;
  padding: 0 10px 1px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.38;
  letter-spacing: 0.05em;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 0 8px 1px;
  }
`;

const NewsItemArrow = styled.div.attrs({className: 'news-item-arrow'})`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 22px;
    height: 22px;
  }
  @media (min-width: 769px) {
    transform: translateX(0px);
    transition: transform 0.3s ease;
    
  }
`;

const NewsItemArrowIcon = styled.img.attrs({className: 'news-item-arrow'})`
  width: 16px;
  height: 16px;

  @media (max-width: 768px) {
    width: 14px;
    height: 14px;
  }
`;


const CategoryDot = styled.div.attrs({className: 'category-dot'})<{ $color: string; $isActive?: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: ${props => props.$color};
  opacity: ${props => props.$isActive ? '1' : '1'};

  @media (max-width: 768px) {
    width: 10px;
    height: 10px;
  }
`;

const NewsCategoryItem = styled.button.attrs({className: 'news-category-item'})<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 15px;
  height: 28px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.75em;
  letter-spacing: 0.05em;
  color: #333333;
  opacity: ${props => props.$isActive ? '1' : '0.2'};
  transition: opacity 0.3s ease;
  
  &:hover {
    opacity: 1;
  }

  @media (max-width: 768px) {
    gap: 12px;
    height: 24px;
  }
    &:nth-child(3) {/*フロム人事は非表示*/
      display: none;
    }
`;



 const categoryNames = [ 'お知らせ', 'リリース', 'フロム人事'];

const TopPage: React.FC = () => {
   // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);

  }, []);

  // Use data service hook for news data
  const {
    posts,
    loading,
    error,
    categories,
    filterByCategory,
    activeCategory
  } = useDataService(4); // Get 4 latest posts for the news section

  // Get category color helper function
  const getCategoryColor = (categoryName: string) => {
    switch (categoryName.toLowerCase()) {
      case 'お知らせ':
      case 'news':
        return '#FDC22D';
      case 'リリース':
      case 'release':
        return '#92D382';
      case 'フロム人事':
      case 'fromrecruit':
        return '#FF9294';
      default:
        return '#FDC22D';
    }
  };

  // Handle category filter
  const handleCategoryFilter = (categoryId: number | null) => {
    filterByCategory(categoryId);
  };

  const pathVariants = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: { 
      pathLength: 1, 
      opacity: 1,
      transition: { 
        duration: 0.8, // 1つのパーツを描く時間
        ease: "easeInOut" 
      }
    }
  } as const;
  // 追加：SVG本体に適用する設定
  const svgContainerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        // 2つ目のpが動き出してから、さらにどれくらい待ってSVGを描き始めるか
        delayChildren: 1, // ← ここでさらに遅らせる
        staggerChildren: 0.1, 
        staggerDirection: -1 
      }
    }
  };  


  const container = {
    hidden: { opacity: 1 },
    visible: {
      transition: {// 2つのテキストの表示間隔
        // 画像が動き出してから、何秒後にテキストを開始するか。
        // 0.3〜0.5秒くらいにすると「画像が出終わる前」に文字が動き出します。
        delayChildren: 1, 
        staggerChildren: 0.1
      }
    }
  };

  const kvItemVariants = {//1行目
    hidden: { width: 0 },
    visible: {
      width: "100%",
      transition: {
        duration: 0.7,
        ease: "easeInOut",
      },
    },
  }as const;

  const kvItemVariants2 = {//2行目
    hidden: { width: 0 },
    visible: {
      width: "fit-content",
      transition: {
        delay: 1.5,
        duration: 0.6,
        ease: "easeInOut",
      },
    },
  }as const;


  const imageVariants = {
    hidden: { 
      opacity: 0, 
      scale: 1.1 // ★最初、ちょっと大きくしておく
    },
    visible: {
      opacity: 1,
      scale: 1, // ★通常のサイズに戻す
      transition: { 
        // フェードインのタイミング（青い板に合わせて少し遅らせる）
        opacity: { delay: 0.4, duration: 0.2 },
        // スケールの動き（ふわっと戻すため、長めの時間をかける）
        scale: { 
          delay: 0.4, // 青い板の動きと同期
          duration: 1.2, // ★ゆっくり戻す
          ease: [0.22, 1, 0.36, 1] // ★滑らかなeaseOut
        }
      }
    }
  } as const;
  const imageStyle = {
    width: '100%',
    height: '100vh',
    objectFit: 'cover',
    display: 'block',
  } as const;
  
  const [isImageDone, setIsImageDone] = useState(false);

  return (
    <TopPageContainer>
      {/* Top Banner Image */}
      <TopBannerImage $imageSrc="/assets/images/top/top-page-image.jpg">
      <motion.img
        src="/assets/images/top/top-page-image.jpg"
        alt=""
        initial="hidden"
        whileInView="visible" // 画面に入ったら再生
        viewport={{ once: true }} // 要素が50%見えたら実行
        variants={imageVariants}
        style={imageStyle}
        onAnimationComplete={() => setIsImageDone(true)} // 完了時にフラグを立てる
      />


        <TopText>
          <MotionTopTextInner
          className="top-text"
          variants={container}
          initial="hidden"
          animate="visible"
          // animate={isImageDone ? "visible" : "hidden"}
          >
            <motion.p
            variants={kvItemVariants}
            style={{ 
              overflow: "hidden",
              whiteSpace: "nowrap",
            }}
            >
              <TopTextVector1>
                <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/kv-txt-1-pc.svg" 
                />
                <img src="/assets/images/top/kv-txt-1-sp.svg" alt="ITにふれるすべての人々に、" />
                </TopTextVector1>
            </motion.p>
            <TopTextLiner>
              <motion.p
              variants={kvItemVariants2}
              style={{ 
                overflow: "hidden",     // 幅が広がるまで中身を隠す
                whiteSpace: "nowrap",   // 改行を防いで横にスッと出す
              }}
              >
                <TopTextVector2 src="/assets/images/top/kv-txt-2-pc.svg" alt="うれしいを。" />
              </motion.p>
              <motion.svg
                className="top-text-vector-2-2"
                width="247"
                height="97"
                viewBox="0 0 247 97"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                variants={svgContainerVariants}
              >
                {/* 各パーツを motion.path に書き換え */}
                <motion.path variants={pathVariants} d="M229.789 22.377C232.727 19.4514 237.446 24.7136 239.232 27.0247C240.198 28.273 245.729 37.2034 246.017 38.2213C246.587 40.2314 244.974 42.7537 242.855 42.568C240.32 42.344 238.969 36.0127 237.67 33.7144C237.055 32.6326 235.57 30.424 234.744 29.5981C232.791 27.6456 226.172 25.9812 229.789 22.3834V22.377Z" stroke="white" strokeWidth="1" fill="white" />
                <motion.path variants={pathVariants} d="M204.029 45.2631C204.65 45.9993 206.782 43.4835 207.204 43.0033C210.008 39.8601 213.753 32.2677 216.224 30.2639C219.623 27.4984 222.709 30.5776 220.584 34.6235C219.585 36.5248 211.916 45.9609 210.123 47.8622C207.928 50.1925 204.983 52.3498 201.737 50.4293C198.504 48.5152 199.228 41.7038 198.895 38.5541C198.491 34.7835 195.476 27.0759 201.475 26.967C206.013 28.177 203.325 34.7387 203.325 37.9076C203.325 40.1674 204.579 42.7729 204.022 45.2695L204.029 45.2631Z" stroke="white" strokeWidth="1" fill="white" />
                
                <motion.path variants={pathVariants} d="M157.774 23.0172C159.797 25.021 157.243 27.1271 156.712 28.9964C155.937 31.7492 155.399 38.0741 155.342 41.0701C155.265 45.0583 155.386 49.61 157.717 52.9837C158.683 53.1117 159.56 52.9452 160.463 52.5932C163.664 51.3384 172.024 42.216 174.559 39.1688C177.325 35.8527 182.754 23.555 186.601 31.6019C186.697 32.7094 184.898 35.014 184.156 35.9615C180.513 40.6347 166.583 56.0565 161.59 57.5609C157.134 58.9052 155.041 57.9002 152.685 54.0207C149.951 49.5267 150.399 35.2253 150.899 29.579C151.014 28.2922 151.501 25.3475 152.006 24.2848C152.979 22.2682 156.219 21.4616 157.768 23.0044L157.774 23.0172Z" stroke="white" strokeWidth="1" fill="white" />
                
                <motion.path variants={pathVariants} d="M115.045 35.6607C109.175 41.1918 103.708 47.171 98.4005 53.2654C97.6003 54.1872 96.2816 54.4433 95.5518 55.538C92.575 60.0384 97.1586 72.4705 93.9321 74.4038C88.4779 77.6623 88.7083 66.7154 90.0783 63.8346C88.2218 62.2854 82.0249 75.4729 78.5744 73.7829C77.9534 73.482 76.4362 71.5743 76.2506 70.8893C75.6744 68.7831 83.2669 53.1566 82.3962 49.1043C79.7523 51.6522 71.8462 56.9656 70.7067 60.1664C70.0921 61.8885 71.9166 62.8807 69.5736 64.7757C67.9028 66.1264 66.4432 65.6591 65.1052 64.1611C62.4869 61.2227 65.054 58.7068 67.0129 56.4598C68.9718 54.2128 81.2887 42.9138 83.4013 42.709C90.8977 41.9664 85.9684 56.3318 84.9697 59.9936C88.273 57.7658 89.9503 56.2614 90.1423 51.9914C90.3984 46.3195 90.648 37.0819 90.1039 31.4868C89.8414 28.734 87.6264 27.8762 89.7774 24.8034C91.6083 22.1915 94.2714 22.8957 95.1932 25.7636L94.5659 49.1107C95.7566 49.3091 96.416 48.2784 97.1394 47.5294C100.34 44.2262 112.772 29.0925 116.063 28.6188C122.989 27.6201 119.373 41.3646 119.545 44.9367C119.629 46.6908 120.653 53.1886 122.087 53.9248C128.335 56.9016 136.74 38.8743 141.631 43.3363C142.227 43.8805 142.604 45.244 142.476 46.0827C142.086 48.6177 128.975 58.6108 126.114 59.1998C123.073 59.8271 119.116 59.6479 117.337 56.7415C117.081 56.3254 115.051 51.6393 115.051 51.3449V35.6607H115.045Z" stroke="white" strokeWidth="1" fill="white" />
                
                <motion.path variants={pathVariants} d="M23.0178 95.6767C22.0575 94.7037 22.0575 92.6295 22.5569 91.3812C23.8308 88.1867 31.3144 81.5674 33.6382 78.1232C36.519 73.8469 40.2832 66.2161 42.543 61.4212C44.9117 56.383 46.845 51.2104 47.8757 46.2683C48.7335 42.1328 52.2352 34.1435 45.5454 33.132C38.0554 31.9989 18.8183 42.7218 12.6598 47.5423C9.29253 48.989 5.18903 57.721 1.37361 54.9106C-0.732553 53.3614 -0.175603 51.3961 1.42483 49.738C5.65636 45.3401 19.4648 36.6145 25.1944 33.8234C32.9661 30.04 52.5745 21.6857 54.2326 35.9744C55.6089 47.8623 41.7684 74.3526 34.9186 84.5186C33.4014 86.772 27.2237 96.2657 25.124 96.4385C24.4454 96.3361 23.4979 96.1505 23.0242 95.6703L23.0178 95.6767Z" stroke="white" strokeWidth="1" fill="white" />
                
                <motion.path variants={pathVariants} d="M27.8175 0.617645C28.5665 1.37945 30.0069 4.48427 31.1976 5.87345C33.1565 8.14606 35.3331 10.3098 37.5161 12.3648C39.5262 15.4056 36.2933 18.4528 33.3806 16.5003C31.8698 13.1394 22.5361 5.6814 22.8434 2.71101C23.0482 0.732878 26.2747 -0.950775 27.8239 0.617645H27.8175Z" stroke="white" strokeWidth="1" fill="white" />
              </motion.svg>
            </TopTextLiner>
            
          </MotionTopTextInner>
        </TopText>
      </TopBannerImage>
      
            {/* News Section */}
      <NewsSection>
        <NewsContainer>
          <NewsHeader>
            <NewsSectionTitle>
              <MainTitle>お知らせ</MainTitle>
              <SubTitle>Information</SubTitle>
            </NewsSectionTitle>
          </NewsHeader>
          <NewsContent>
            {/* Left side: Categories and Button */}
            <NewsLeftSide>
              <FilterContainer>
              <CategoryFilterDivider/>
              <NewsCategories>
                <NewsCategoryItem 
                  $isActive={activeCategory === null}
                  onClick={() => handleCategoryFilter(null)}
                >
                  <CategoryDot $color="#333333" $isActive={activeCategory === null} />
                  <span>新着</span>
                </NewsCategoryItem>
                {categories.map((category) => (
                  categoryNames.includes(category.name) &&
                  <NewsCategoryItem 
                    key={category.id}
                    $isActive={activeCategory === category.id}
                    onClick={() => handleCategoryFilter(category.id)}
                  >
                    <CategoryDot 
                      $color={getCategoryColor(category.name)} 
                      $isActive={activeCategory === category.id} 
                    />
                    <span>{category.name}</span>
                  </NewsCategoryItem>
                ))}
              </NewsCategories>
              <CategoryFilterDivider/>
              </FilterContainer>

              
              {!loading && (
                <NewsButton to="/information">
                  一覧を見る
                  <NewsButtonArrow src="/images/arrow-right.svg" alt="arrow right" />
                </NewsButton>
              )}
            </NewsLeftSide>
            
            {/* Right side: News Items */}
            <NewsRightSide>
              {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>読み込み中...</div>
              ) : error ? (
                <div style={{ textAlign: 'center', padding: '20px', color: '#ff0000' }}>エラー: {error}</div>
              ) : posts.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>記事が見つかりません</div>
              ) : (
                posts.map((post) => (
                  <NewsItem key={post.id} to={`/information/${post.id}`}>
                    <NewsItemContent>
                      <NewsItemMeta>
                        <span>
                          {new Date(post.date).toLocaleDateString('ja-JP', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit'
                          }).replace(/\//g, '.')}
                        </span>
                        {post._embedded?.['wp:term']?.[0]?.[0] && (
                          <CategoryTag $color={getCategoryColor(post._embedded['wp:term'][0][0].name)}>
                            {post._embedded['wp:term'][0][0].name}
                          </CategoryTag>
                        )}
                      </NewsItemMeta>
                      <NewsItemTitle 
                        dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                      />
                    </NewsItemContent>
                    <NewsItemArrow>
                      <NewsItemArrowIcon src="/images/arrow-right.svg" alt="arrow right" />
                    </NewsItemArrow>
                  </NewsItem>
                ))
              )}
            </NewsRightSide>
            {!loading && (
              <NewsButtonMobile to="information">
                一覧を見る
                <NewsButtonArrow src="/images/arrow-right.svg" alt="arrow right" />
              </NewsButtonMobile>
            )}
          </NewsContent>
        </NewsContainer>
      </NewsSection>


      {/* Hero Section */}
      <HeroSection>
        <HeroContent>
          {/* Left side: Philosophy Title */}
          <HeroLeftSide>
            <PhilosophyTitle>
              <MainTitleWhite>企業理念</MainTitleWhite>
              <SubTitle>Philosophy</SubTitle>
            </PhilosophyTitle>
          </HeroLeftSide>
          
          {/* Right side: Title and Description */}
          <HeroText>
            <HeroTitle>ITにふれるすべての人々に、うれしいを。</HeroTitle>
            <HeroDescription>
              私たちは最先端の技術を駆使し、人々が抱える様々な困難に立ち向かい、その解決を支援することで希望に満ち溢れた豊かな未来社会の創造します。
            </HeroDescription>
            <HeroButton to="/philosophy">
              詳しく見る
              <HeroButtonArrow src="/images/arrow-right.svg" alt="arrow right" />
            </HeroButton>
          </HeroText>
        </HeroContent>
        
        {/* Bottom: Image List with 3 images */}
        <HeroImageList>
          <HeroImangeWrapper>
            <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-1.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-1.jpg" alt="Hero Image 1" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
          <HeroImageItem>
            <source 
                media="(min-width: 769px)" 
                srcSet="/assets/images/top/hero-image-2.jpg" 
              />
              <img src="/assets/images/top/hero-image-sp-2.jpg" alt="Hero Image 2" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
            <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-3.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-3.jpg" alt="Hero Image 3" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
          <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-4.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-4.jpg" alt="Hero Image 4" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
          <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-5.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-5.jpg" alt="Hero Image 5" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
          <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-6.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-6.jpg" alt="Hero Image 6" />
            </HeroImageItem>
          </HeroImangeWrapper>
          {/* Repeat */}
          <HeroImangeWrapper>
            <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-1.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-1.jpg" alt="Hero Image 1" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
          <HeroImageItem>
            <source 
                media="(min-width: 769px)" 
                srcSet="/assets/images/top/hero-image-2.jpg" 
              />
              <img src="/assets/images/top/hero-image-sp-2.jpg" alt="Hero Image 2" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
            <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-3.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-3.jpg" alt="Hero Image 3" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
          <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-4.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-4.jpg" alt="Hero Image 4" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
          <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-5.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-5.jpg" alt="Hero Image 5" />
            </HeroImageItem>
          </HeroImangeWrapper>
          <HeroImangeWrapper>
          <HeroImageItem>
              <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/hero-image-6.jpg" 
                />
              <img src="/assets/images/top/hero-image-sp-6.jpg" alt="Hero Image 6" />
            </HeroImageItem>
          </HeroImangeWrapper>
        </HeroImageList>
        {/* Mobile-only Hero Button */}
        <MobileHeroButton to="/philosophy">
            詳しく見る
            <HeroButtonArrow src="/images/arrow-right.svg" alt="arrow right" />
          </MobileHeroButton>
      </HeroSection>

      {/* Service Preview Section */}
      <ServicePreviewSection>
        <ServicePreviewContainer>
          <ServiceSectionTitle>
            <MainTitle>事業紹介</MainTitle>
            <SubTitle>Service</SubTitle>
          </ServiceSectionTitle>
          
          {/* Description Text */}
          <ServiceDescription>
            <ServiceDescriptionTitle>
              課題の特定から提案、<br />
              解決まで包括的なソリューションを提供
            </ServiceDescriptionTitle>
            <ServiceDescriptionText>
              プロフェッショナルがチームを組み、多角的な視点から解決策の実行、効果検証まで、全工程において専門知識と経験を駆使し、ビジネスを徹底的にサポートいたします。
            </ServiceDescriptionText>
          </ServiceDescription>
        </ServicePreviewContainer>
        
        {/* Service Preview Grid - Now outside the container for full width */}
        <ServicePreviewGrid>
          <ServicePreviewCard to="/service/development/">
            <ServicePreviewImage>
              <source 
                media="(min-width: 769px)" 
                srcSet="/assets/images/top/service-development-pc.jpg" 
              />
              <img src="/assets/images/top/service-development-sp.jpg" alt="開発イメージ" />
            </ServicePreviewImage>
            <ServicePreviewContent>
              <ServicePreviewTitle>開発</ServicePreviewTitle>
              <ServicePreviewDescription>
                クライアントのビジネスを深く理解し、最適なソリューションを提供することで、課題解決と事業成長に貢献します。
              </ServicePreviewDescription>
              <ServicePreviewButton>
                詳しく見る
                <ServicePreviewButtonArrow src="/images/arrow-right.svg" alt="arrow right" />
              </ServicePreviewButton>
            </ServicePreviewContent>
          </ServicePreviewCard>
          <ServicePreviewCard to="/service/creative/">
            <ServicePreviewImage>
              <source 
                media="(min-width: 769px)" 
                srcSet="/assets/images/top/service-creative-pc.jpg" 
              />
              <img src="/assets/images/top/service-creative-sp.jpg" alt="クリエイティブイメージ" />
            </ServicePreviewImage>
            <ServicePreviewContent>
              <ServicePreviewTitle>クリエイティブ</ServicePreviewTitle>
              <ServicePreviewDescription>
                Webサイトやランディングページ制作からブランディング戦略立案まで、お客様のデジタルプレゼンスを最大化します。
              </ServicePreviewDescription>
              <ServicePreviewButton>
                詳しく見る
                <ServicePreviewButtonArrow src="/images/arrow-right.svg" alt="arrow right" />
              </ServicePreviewButton>
            </ServicePreviewContent>
          </ServicePreviewCard>
          <ServicePreviewCard to="/service/product/">
            <ServicePreviewImage>
              <source 
                media="(min-width: 769px)" 
                srcSet="/assets/images/top/service-product-pc.jpg" 
              />
              <img src="/assets/images/top/service-product-sp.jpg" alt="プロダクトイメージ" />
            </ServicePreviewImage>
            <ServicePreviewContent>
              <ServicePreviewTitle>プロダクト</ServicePreviewTitle>
              <ServicePreviewDescription>
              作り手の気持ちを理解したいという想いから、デジタル領域の知見とものづくりへの情熱を融合し、バッグブランド「FADEN®︎」を展開しています。
              </ServicePreviewDescription>
              <ServicePreviewButton>
                詳しく見る
                <ServicePreviewButtonArrow src="/images/arrow-right.svg" alt="arrow right" />
              </ServicePreviewButton>
            </ServicePreviewContent>
          </ServicePreviewCard>
        </ServicePreviewGrid>
      </ServicePreviewSection>

      {/* Client Section */}
      <ClientSection>
        <ClientContainer>
          <ClientSectionTitle>
            <MainTitle>主要取引先</MainTitle>
            <SubTitle>Client</SubTitle>
          </ClientSectionTitle>
          <ClientLogos>
      
            {/* 3. これが実際に横に動く「コンテナ」 */}
            <motion.div
              className="logos-slide"
              style={{ 
                display: "flex", // ロゴを横並びに
                width: "fit-content" // 中身の合計幅に合わせる
              }}
              animate={{ 
                // ロゴ1組分（100% / 2）だけ左に移動
                x: "-33.333%", 
              }}
              transition={{ 
                duration: 50,         // 20秒かけて一周（ロゴの数や速さで調整）
                ease: "linear",       // 等速運動にする（滑らかに繋がる）
                repeat: Infinity,     // 無限ループ
              }}
            >
              {INFINITE_LOGOS.map((logo, index) => (
                // ロゴを囲む motion.div (間隔調整用)
                <motion.div 
                  key={index} 
                >
                  {/* 4. あなたのコンポーネント */}
                  <ClientLogo 
                    src={logo} 
                    alt={`Client Logo ${index + 1}`} 
                    // スタイル調整が必要ならここに追加
                  />
                </motion.div>
              ))}
            </motion.div>
          </ClientLogos>
        </ClientContainer>
      </ClientSection>

      {/* Recruitment Section */}
      <RecruitmentSection>
        
        <RecruitmentContainer>
          <RecruitmentLeftSide>
            {/* Recruitment Subsection Title */}
            <RecruitmentSubsectionTitle>
              <MainTitleWhite>採用情報</MainTitleWhite>
              <SubTitle>Recruit</SubTitle>
            </RecruitmentSubsectionTitle>
            
            <RecruitmentText>
              <RecruitmentTitle>メンバー同士で互いに高め合い、そして最高の成果を</RecruitmentTitle>
              <RecruitmentDescription>
                挑戦と成長の先に、社会を変えるインパクトを。常に挑戦し続け、成長を求めることで、社会に大きなインパクトを与えることを目指す、そんな熱い想いを持つ仲間を探しています。
              </RecruitmentDescription>
              <RecruitmentButtons>
                <RecruitmentButton to="https://herp.careers/v1/xelen/requisition-groups/85f61ffa-d967-4da7-b8a3-8383d0487941" target="_blank">
                  新卒採用
                  <LinkRightIcon src="/images/link-right-icon.svg" alt="link right" />
                </RecruitmentButton>
                <RecruitmentButton to="https://herp.careers/v1/xelen" target="_blank">
                  中途採用
                  <LinkRightIcon src="/images/link-right-icon.svg" alt="link right" />
                </RecruitmentButton>
              </RecruitmentButtons>
            </RecruitmentText>
          </RecruitmentLeftSide>
          <RecruitmentImageWrapper>
            <RecruitmentImage>
                <source 
                  media="(min-width: 769px)" 
                  srcSet="/assets/images/top/recruitment.png" 
                />
                <img src="/assets/images/top/recruitment-sp.png" alt="メンバーイメージ" />
            </RecruitmentImage>
          </RecruitmentImageWrapper>
        </RecruitmentContainer>
      </RecruitmentSection>



      {/* Contact Section */}
      <ContactSection />


      <Footer />
    </TopPageContainer>
  );
};

export default TopPage;
